/**
 * Wrapper for tool body content
 */
import React from "react";
import { Box, Typography } from "@mui/material";

/**
 *
 * @param {string} param0.title - Tool title
 * @param {React.ReactNode} param0.children - Tool body content
 * @returns {JSX.Element}
 * @component
 */
const ToolBody = ({ title = null, children }) => {
  return (
    <Box
      className="body-inner-sec"
      sx={{ marginLeft: "260px !important", p: 2 }}
    >
      {title && (
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default ToolBody;
